/**
 * 后端 API 封装，统一 baseURL 与跨域
 */
import axios from 'axios'
import { banners, services, partners, newsList } from '@/mock/data'

// 留空或未设置 = 与前端同域（Nginx 代理时用）；换服务器只改 .env.production 里的 VUE_APP_API_URL
const raw = process.env.VUE_APP_API_URL
const baseURL = (raw !== undefined && raw !== null && raw !== '')
  ? raw
  : ''

const request = axios.create({
  baseURL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
})

// Mock 拦截器：当后端不可用时使用 mock 数据
request.interceptors.response.use(
  response => response,
  error => {
    const config = error.config
    if (error.response?.status === 404 || error.code === 'ECONNREFUSED') {
      // 根据请求 URL 返回对应的 mock 数据
      if (config.url === '/api/banners') {
        return Promise.resolve({ data: banners })
      }
      if (config.url === '/api/services') {
        return Promise.resolve({ data: services })
      }
      if (config.url === '/api/partners') {
        return Promise.resolve({ data: partners })
      }
      if (config.url === '/api/news') {
        return Promise.resolve({ data: newsList })
      }
      if (config.url === '/api/news/read_counts') {
        return Promise.resolve({ data: {} })
      }
      if (config.url === '/api/insurance') {
        return Promise.resolve({ data: newsList })
      }
      if (config.url === '/api/insurance/read_counts') {
        return Promise.resolve({ data: {} })
      }
    }
    return Promise.reject(error)
  }
)

// 广告
export const getBanners = () => request.get('/api/banners')
export const getBanner = id => request.get(`/api/banners/${id}`)

// 服务推荐（已下线，保留接口兼容）
export const getServices = () => request.get('/api/services')
export const getService = id => request.get(`/api/services/${id}`)

// 合作伙伴
export const getPartners = () => request.get('/api/partners')

// 行业资讯
export const getNewsList = () => request.get('/api/news')
export const getNewsById = id => request.get(`/api/news/${id}`)
export const getNewsReadCounts = () => request.get('/api/news/read_counts')
export const getNewsReadCount = id => request.get(`/api/news/${id}/read_count`)
export const incrementNewsRead = id => request.post(`/api/news/${id}/read`)

// 保险信息
export const getInsuranceList = () => request.get('/api/insurance')
export const getInsuranceById = id => request.get(`/api/insurance/${id}`)
export const getInsuranceReadCounts = () => request.get('/api/insurance/read_counts')
export const getInsuranceReadCount = id => request.get(`/api/insurance/${id}/read_count`)
export const incrementInsuranceRead = id => request.post(`/api/insurance/${id}/read`)

// bx 页面配置
export const getCpicSettings = (id = 1) => request.get(`/api/bx/settings/${id}`)
